<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { ImageSize } from './Utils';
    import LinkCollectionInner from './LinkCollectionInner.svelte';
    import LinkCollectionWithOnlySharedPost from './LinkCollectionWithOnlySharedPost.svelte';

    export let links: string[];
    export let sharedPostId: number | null = null;
    export let linkClass: string = '';
    export let maxSize: ImageSize = null;

    const _dispatch = createEventDispatcher<{
        ids: number[];
    }>();
</script>

{#if sharedPostId != null}
    <LinkCollectionWithOnlySharedPost {sharedPostId} on:ids />
{:else}
    <LinkCollectionInner on:ids {links} {linkClass} {maxSize} />
{/if}
